import React from 'react';

type InputProps = {
  className?: string;
  defaultValue?: string;
  errorMessage?: string;
  href?: string;
  id?: string;
  maxLength?: number;
  name?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  readOnly?: boolean;
  type: string;
  title?: string;
  value?: string;
  disabled?: boolean;
  size?: number;
  checked?: boolean;
  onFocus?: (event: React.FocusEvent) => void;
  defaultChecked?: boolean;
}

class Input extends React.Component< InputProps, {} > {
  render(): JSX.Element {
    return (
        <input {...this.props} />
    );
  }
}

export default Input;

